import React from "react";
import styles from "./BlogPost.module.css";
import { formatDate } from "./reviewDetail/ReviewDetail";
import { useNavigate } from "react-router-dom";
import SocialShareIcons from "../case-studies/SocialShareIcons";

const BlogPost = ({
  image,
  metatitle,
  name,
  description,
  socialStats,
  createdAt,
  _id,
  slug,
  metadescription,
  metakeywords,
  homeDescription
}) => {
  const navigate = useNavigate();
  

  return (
    <article
      data-aos="fade-right"
      data-aos-delay="200"
      className={styles.blogPost}
      onClick={() => navigate(`/reviews-and-blogs/${slug}`)}
    >
      <img src={image} alt="" className={styles.postImage} />
      <div className={styles.postContent}>
        <header className={styles.postHeader}>
          <div className={styles.postMeta}>
            {/* <span className={styles.category}>{metatitle}</span>
            <span className={styles.separator}>&nbsp;/&nbsp;</span> */}
            <time className={styles.date}>{formatDate(createdAt)}</time>
            <span className={styles.separator}>&nbsp;/&nbsp;</span>
            <span className={styles.author}>{"BY BODYSHOPINDIA"}</span>
          </div>
          {socialStats && (
            <div className={styles.socialStats}>
              <span className={styles.separator}>/</span>
              <img
                src="/img/bodyshop/blue-dot.svg"
                alt=""
                className={styles.statIcon}
              />
              <span className={styles.statCount}>{socialStats}</span>
            </div>
          )}
        </header>
        <h2 className={styles.postTitle}>{name}</h2>
        {/* <div
          className={styles.postExcerpt}
          dangerouslySetInnerHTML={{ __html: metadescription }}
        /> */}
        <p className={styles.postExcerpt} dangerouslySetInnerHTML={{ __html: homeDescription }}></p>
        <SocialShareIcons
          shareUrl={`${window.location.href}/${slug}`}
          title={name}
        />
      </div>
    </article>
  );
};

export default BlogPost;
